module.exports = __webpack_public_path__ + "c521e40e04e61f31e814e29ccc5e2d78.svg";